import styles from './TimerDisplay.module.css';

export interface TimerDisplayProps {
  seconds: number;
  isUrgent: boolean;
  isMyTurn: boolean;
}

export function TimerDisplay({ seconds, isUrgent, isMyTurn }: TimerDisplayProps) {
  const showUrgency = isUrgent && isMyTurn;
  const displaySeconds = Math.max(0, Math.floor(seconds));

  return (
    <span
      className={`${styles.timer} ${showUrgency ? styles.urgent : ''}`}
      role="timer"
      aria-live="polite"
      aria-label={`${displaySeconds} seconds remaining${showUrgency ? ', time is running out' : ''}`}
    >
      {displaySeconds}
    </span>
  );
}
